<template>
  <!-- 최상위 div 시작 -->
  <div>
    <!-- 반복되는 노드 영역 -->
    <div
      class="node pl--20px"
      @drag.stop="drag"
      draggable="true"
    >
      {{type}}
    </div><!-- 반복되는 노드 영역 끝 -->

    <!-- 형제노드 추가 : 현재 주석 하단에 추가 -->
    <!-- 형제노드 끝 -->

  </div><!-- 최상위 div 끝 -->
</template>

<script>
import eventBus from '@/component/common/EventBus'

export default {
  name: 'AddNode',
  props: {
    type: { type: String }
    // node: { type: Object }
  },
  data () {
    return {
    }
  },
  methods: {
    drag (e) {
      eventBus.$emit('add-tree-node', this.type)
    }
  },
  components: {
  }
}
</script>
